var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getCookie } from '../src/utils/browser';
// always enable validation when testing
var enableValidationCookieValue = getCookie('enableValidation');
export var ENABLE_VALIDATION = process.env.NODE_ENV === 'test' ? true : !!(enableValidationCookieValue && enableValidationCookieValue.toLowerCase() === 'true');
var ValidationError = /** @class */ (function (_super) {
    __extends(ValidationError, _super);
    function ValidationError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ValidationError.prototype);
        return _this;
    }
    return ValidationError;
}(Error));
export { ValidationError };
// we can assume the ErrorObject list has a max length of one because allMessages = false when initiating AJV in
// 'cmd/jsonschema2typescript.ts' and 'cmd/openapi2typescript.ts'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function formatValidationError(validatorName, errors, data) {
    if (!errors || errors.length < 0) {
        return "".concat(validatorName, " failed!");
    }
    // we can assume the message field is not undefined because we have set messages = true when initiating AJV in
    // 'cmd/jsonschema2typescript.ts' and 'cmd/openapi2typescript.ts'
    return "".concat(validatorName, " failed! '").concat(errors[0].message, "' at '").concat(errors[0].instancePath, "'");
}
export function tryParse(value) {
    if (typeof value !== 'string') {
        return value;
    }
    try {
        return JSON.parse(value);
    }
    catch (_a) {
        return value;
    }
}
export function tryParseResponse(response) {
    return __awaiter(this, void 0, Promise, function () {
        var responseText, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(response instanceof XMLHttpRequest)) return [3 /*break*/, 1];
                    _a = response.responseText;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, response.text()];
                case 2:
                    _a = _b.sent();
                    _b.label = 3;
                case 3:
                    responseText = _a;
                    return [2 /*return*/, {
                            data: tryParse(responseText),
                            status: response.status,
                        }];
            }
        });
    });
}
